import { ApiService } from '@services/core-services/api.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from '@services/auth-services/token.service';
import { AppService } from '@services/core-services/app.service';
import { RequestQueueService } from '@services/core-services/api-queue.service';

@Injectable({ providedIn: 'root' })
export class StoreApiService extends ApiService {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly tokenService: TokenService,
    protected override readonly appService: AppService,
    protected override readonly requestQueue: RequestQueueService
  ) {
    super(http, tokenService, appService, requestQueue);
  }

  override getBaseUrl() {
    return this.appService.getTenantBaseUrl();
  }

  override withHeaders(): HttpHeaders {
    const bearer = this.tokenService.getAccessToken();
    return this.withAuthBearerHeader(bearer);
  }
}

@Injectable({ providedIn: 'root' })
export class StoreAdminApiService extends ApiService {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly tokenService: TokenService,
    protected override readonly appService: AppService,
    protected override readonly requestQueue: RequestQueueService
  ) {
    super(http, tokenService, appService, requestQueue);
  }

  override getBaseUrl() {
    return this.appService.getBaseUrl();
  }

  override withHeaders(): HttpHeaders {
    return this.withApiKeyHeader();
  }
}
